import ProductIcon from '@mui/icons-material/Collections';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ProductList from './ProductList';
import ProductEdit from './ProductEdit';
import ProductCreate from './ProductCreate';

export default {
    list: ProductList,
    create: ProductCreate,
    edit: ProductEdit,
    icon: ProductIcon,
    iconSales: ReceiptIcon,
};
